export function createObject<T>(ctor: new () => T) {
  return () => new ctor();
}
